import { render, staticRenderFns } from "./ServiceConfigs.vue?vue&type=template&id=12397abe&scoped=true&"
import script from "./ServiceConfigs.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigs.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConfigs.vue?vue&type=style&index=0&id=12397abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12397abe",
  null
  
)

export default component.exports